import { render, staticRenderFns } from "./TemplateEditorAddPlaceholder.vue?vue&type=template&id=3e3f5c79&scoped=true"
import script from "./TemplateEditorAddPlaceholder.vue?vue&type=script&lang=ts"
export * from "./TemplateEditorAddPlaceholder.vue?vue&type=script&lang=ts"
import style0 from "./TemplateEditorAddPlaceholder.vue?vue&type=style&index=0&id=3e3f5c79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3f5c79",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
